export default "__VITE_ASSET__1f1dd0f2__"